<template>

    <div id="sidebar-container" class="sidebar-expanded ">
      <ul class="list-group">

        <el-tooltip :content="$t('menu.0')" placement="right">
          <router-link to="/panel" class="list-group-item list-group-item-action">
            <i class="i-Bar-Chart"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip :content="$t('menu.9')" placement="right">
          <router-link to="/teklif" class="list-group-item list-group-item-action">
            <i class="i-Receipt-4"></i>
          </router-link>
        </el-tooltip>

    <el-tooltip :content="$t('menu.1')" placement="right">
          <router-link to="/gelir" class="list-group-item list-group-item-action">
            <i class="i-Checkout"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip :content="$t('menu.2')" placement="right">
          <router-link to="/gider" class="list-group-item list-group-item-action">
            <i class="i-Up"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip :content="$t('menu.3')" placement="right">
          <router-link to="/urun" class="list-group-item list-group-item-action">
            <i class="i-Tag-4"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip :content="$t('menu.4')" placement="right">
          <router-link to="/stok" class="list-group-item list-group-item-action">
            <i class="i-Bar-Code"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip :content="$t('menu.5')" placement="right">
          <router-link to="/cari" class="list-group-item list-group-item-action">
            <i class="i-Business-ManWoman"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip :content="$t('menu.6')" placement="right">
          <router-link to="/kasa" class="list-group-item list-group-item-action">
            <i class="i-Password-shopping"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip :content="$t('menu.7')" placement="right">
          <router-link to="/kategori" active="" class="list-group-item list-group-item-action">
            <i class="i-Folders"></i>
          </router-link>
        </el-tooltip>


        <!--el-tooltip :content="$t('menu.8')" placement="right">
          <router-link to="takvim" class="list-group-item list-group-item-action">
            <i class="i-Calendar-4"></i>
          </router-link>
        </el-tooltip-->




      </ul>
    </div>

</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Doc/Sidebar.vue